const globalConfig = document.body.dataset || {};

const config = {
  baseUrl: globalConfig.vueWidgetBaseUrl || '/',
  baseApiUrl: globalConfig.vueWidgetBaseApiUrl || '/api/',
  wssChatUrl: globalConfig.vueWidgetBaseWssUrl || 'onb-familien-ts.lfrz.gv.at',
  baseSearchHref: globalConfig.vueWidgetSearchBaseUrl || '/',
  tagUrl: globalConfig.vueWidgetTagurl || '/',
  pagingSize: 20,
}
export default config

